module.exports = __webpack_public_path__ + "media/images/countryrect/kz-87584b8fd8dc9f24ff2862f38959bdac.svg";